function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.8 17.8H1.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2h9.4V1.8c0-.7.5-1.2 1.2-1.2h11c.7 0 1.2.5 1.2 1.2S23.5 3 22.8 3H13v13.6c0 .7-.5 1.2-1.2 1.2z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18"
  }, props), _ref);
};

export default SvgComponent;